import { render, staticRenderFns } from "./DetalleProductoDialog.vue?vue&type=template&id=1d313dd6"
import script from "./DetalleProductoDialog.vue?vue&type=script&lang=js"
export * from "./DetalleProductoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports